<mat-chip-listbox style="--chip-margin: {{ MENU_ITEM_GAP / 2 }}px" [attr.aria-label]="ariaLabel">
    <!-- Contains the regular horizontal menu chip items-->
    <mat-chip-option
        *ngFor="let chip of chips; let i = index"
        (click)="selectChip(i)"
        [class.selected]="selectedChipIndex === i"
        class="chip-item"
        [class.offscreen]="isItemHidden(i)"
        [attr.aria-hidden]="isItemHidden(i)"
    >
        {{ chip.displayValue | translate }}
    </mat-chip-option>

    <!--
    The "more" button, is only visible if we've set a numItemsFitInScreenWidth value, meaning not all items fit.
    visibility is used so that the element still has a calculated width.
    This allows us to determine whether it will fit on screen or not
    -->
    <button
        id="more-button"
        class="more-chip"
        *ngIf="numItemsFitInScreenWidth"
        [style.visibility]="numItemsFitInScreenWidth ? 'visible' : 'hidden'"
        role="item"
        [matMenuTriggerFor]="moreMenu"
        (click)="onMoreClick()"
        [attr.tabindex]="numItemsFitInScreenWidth ? 0 : -1"
        [attr.aria-hidden]="!numItemsFitInScreenWidth"
    >
        <mat-chip-option id="more"
            ><span>{{ 'employees.tabs.more' | translate }}</span> <mat-icon svgIcon="chevronDown"></mat-icon
        ></mat-chip-option>
    </button>

    <mat-menu #moreMenu="matMenu" xPosition="before">
        <ng-container *ngFor="let chip of chips.slice(numItemsFitInScreenWidth ?? 0); let i = index">
            <button
                (click)="selectChip(i + (numItemsFitInScreenWidth ?? 0))"
                [class.selected]="selectedChipIndex === i"
                mat-menu-item
            >
                {{ chip.displayValue | translate }}
            </button>
        </ng-container>
    </mat-menu>
</mat-chip-listbox>
